<template>
    <div>
        <b-input-group class="mb-2">
            <b-form-input
                id="current-date"
                v-model="formatted_deadline_date"
                type="text"
                placeholder="Date à définir"
                autocomplete="off"
                size="sm"
                disabled
                class="bg-white"
                style="height: 30px"
            ></b-form-input>
            <b-input-group-append>
                <b-form-datepicker
                    v-model="form.deadline_date"
                    button-only
                    right
                    label-no-date-selected="Date à définir"
                    label-prev-year="Année précédente"
                    label-next-year="Année prochaine"
                    label-prev-month="Mois précédent"
                    label-next-month="Mois prochain"
                    label-current-month="Mois actuel"
                    label-help="Vous pouvez utiliser les flèches du clavier pour naviguer"
                    start-weekday="1"
                    aria-controls="current-date"
                    locale="fr"
                    @context="formatDeadlineDate"
                >
                </b-form-datepicker>
            </b-input-group-append>
        </b-input-group>
        <b-button variant="success" size="sm" block @click="saveDate">
            Enregistrer
        </b-button>
        <hr />
        <b-alert show variant="warning" class="mt-3 mb-0">
            Vous pouvez également désactiver cette échéance
            <b-button
                variant="outline-danger"
                size="sm"
                class="mt-2"
                block
                @click="disableDeadline"
            >
                Désactiver l'échéance
            </b-button>
        </b-alert>
    </div>
</template>

<script>
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'DeadlineDateForm',

    mixins: [DataUpdater],

    props: {
        deadline: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: {},
            formatted_deadline_date: '',
        }
    },

    created() {
        this.form.deadline_date = this.deadline.date
    },

    methods: {
        async saveDate() {
            try {
                await this.$axios.put(
                    `/clientDeadlines/${this.deadline.id}/modal-date`,
                    this.form
                )
                this.$emit('date-has-changed')
            } catch (error) {
                error.log(error)
            }
        },

        async disableDeadline() {
            try {
                await this.$axios.post(
                    `/clientDeadlines/${this.deadline.id}/disable`
                )
                this.$emit('date-has-changed')
            } catch (error) {
                error.log(error)
            }
        },

        formatDeadlineDate(ctx) {
            this.formatted_deadline_date = ctx.selectedFormatted
        },
    },
}
</script>

<style scoped></style>
